import React, { useState } from "react";
import PropTypes from "prop-types";

import { useQuery } from "react-apollo";

import { Column, Field, Control } from "rbx";
import { LocationKeySelect } from "../inputs";

import FilterButtons from "../FilterButtons";

import { ALL_DIRECTIONS_QUERY } from "../../graphql/Directions/Directions.graphql";

const INITIAL_FILTER_STATE = {};

function LocationDirectionFilters({
  locationRecId,
  filters,
  onFilter,
  onClose
}) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    if (value === "0") {
      const keys = Object.keys(inputs).filter(key => key !== e.target.name);
      setInputs({
        ...keys.reduce((acc, curr) => ({ [curr]: inputs[curr] }), {})
      });
    } else {
      setInputs(prevInputs => ({
        ...prevInputs,
        [e.target.name]: e.target.name.includes("RecIdRef")
          ? parseInt(value)
          : value
      }));
    }
  };

  const { data } = useQuery(ALL_DIRECTIONS_QUERY, {
    variables: {
      where: {
        DestinationLocationRecIdRef: parseInt(locationRecId)
        // OR: [
        //   { OriginLocationRecIdRef: parseInt(locationRecId) },
        //   { DestinationLocationRecIdRef: parseInt(locationRecId) }
        // ]
      }
    }
  });
  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () => onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <React.Fragment>
      <Column.Group>
        <Column>
          <Field>
            <Control expanded>
              <LocationKeySelect
                attrKey="LocationID"
                icon="map-pin"
                label="Origin"
                name="OriginLocationRecIdRef"
                value={inputs?.OriginLocationRecIdRef}
                where={{
                  RecId_in: data?.Directions
                    ? [
                        ...new Set(
                          data.Directions.map(d => d.OriginLocationRecIdRef)
                        )
                      ]
                    : null
                }}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control expanded>
              <LocationKeySelect
                attrKey="LocationName"
                icon="map-pin"
                label="Origin"
                name="OriginLocationRecIdRef"
                value={inputs?.OriginLocationRecIdRef}
                where={{
                  RecId_in: data?.Directions
                    ? [
                        ...new Set(
                          data.Directions.map(d => d.OriginLocationRecIdRef)
                        )
                      ]
                    : null
                }}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control expanded>
              <LocationKeySelect
                attrKey="City"
                icon="map-pin"
                label="Origin"
                name="OriginLocationRecIdRef"
                value={inputs?.OriginLocationRecIdRef}
                where={{
                  RecId_in: data?.Directions
                    ? [
                        ...new Set(
                          data.Directions.map(d => d.OriginLocationRecIdRef)
                        )
                      ]
                    : null
                }}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
        <Column>
          <Field>
            <Control expanded>
              <LocationKeySelect
                attrKey="State"
                icon="map-pin"
                label="Origin"
                name="OriginLocationRecIdRef"
                value={inputs?.OriginLocationRecIdRef}
                where={{
                  RecId_in: data?.Directions
                    ? [
                        ...new Set(
                          data.Directions.map(d => d.OriginLocationRecIdRef)
                        )
                      ]
                    : null
                }}
                onChange={handleChange}
              />
            </Control>
          </Field>
        </Column>
      </Column.Group>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </React.Fragment>
  );
}
LocationDirectionFilters.propTypes = {
  locationRecId: PropTypes.number,
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func
};
export default LocationDirectionFilters;
